import isServerSideRendering from './isServerSideRendering';

const IsCarvanaMobileAppUserAgent = (userAgent?: string | undefined) => {
  const agentString = userAgent || navigator.userAgent;
  if (isServerSideRendering) {
    return false;
  }
  return /CarvanaNativeWebView/gi.test(agentString);
};

export default IsCarvanaMobileAppUserAgent;
